import { jsx } from "react/jsx-runtime";
import MuiChip from "@mui/material/Chip/index.js";
import { chipStyles } from "./chip.styles.js";
import "../../themes/shadows/shadows.js";
import "@mui/material";
import "../../themes/typography/typography.js";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
const Chip = ({ variant = "bordered", color = "grey", ...rest }) => {
  return /* @__PURE__ */ jsx(MuiChip, { sx: chipStyles({ variant, color }), ...rest });
};
export {
  Chip
};
